import React from 'react';
import Sidebar from '../Sidebar';

const About = () => {
    return (
        <div>
            <Sidebar />
            <div className="App-Page">
                <h3>I am a Berlin-based creative technologist interested in how everyday encounter with tech- changes the way we think of ourselves as humans. I love real-time 3D and do weird stuff on the web.
                </h3>
            </div>
        </div>
    );
}

export default About;